import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "ecommerce",
    loadChildren: () => import("../../components/ecommerce/ecommerce.module").then((m) => m.EcommerceModule),
  }
];
